




















































































import { defineComponent, ref } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { useIntersectionObserver } from '@vueuse/core';
import { Breadcrumb } from '~/types/components/Breadcrumbs/Breadcrumb';
import { getPageLinkForSlug } from '@/helpers/routes/getPageInformation';
import { usePageEventLocation, useIntegrations } from '~/composables';
import { SCHEMA_ITEM_PROP, SCHEMA_ITEM_TYPE, BREADCRUMBS_HOMEPAGE_PROP_NAME } from '~/constants/seo';
import { TriggerClickBreadcrumbsParameters } from '~/types/integrations/tagManager/TagManagerIntegration';
import { SCROLL_BEHAVIOR_SMOOTH } from '~/constants/ui';

export default defineComponent({
  name: 'Breadcrumbs',
  props: {
    breadcrumbs: {
      type: Array as PropType<Array<Breadcrumb>>,
      default: () => [],
    },
  },
  setup() {
    const BREADCRUMB_SCROLL_OFFSET = 200;
    const { $tagManager } = useIntegrations();
    const { getCurrentPageType } = usePageEventLocation();
    const showRightArrow = ref(false);
    const showLeftArrow = ref(false);
    const lastItemHtml = ref<HTMLElement | null>(null);
    const firstItemHtml = ref<HTMLElement | null>(null);
    const scrollContainer = ref<HTMLElement | null>(null);
    const lastItem = (index, breadcrumbsLength) => breadcrumbsLength - 1 === index;
    const breadcrumbLink = (breadcrumbLink) => {
      return getPageLinkForSlug(breadcrumbLink);
    };

    const currentPageType = getCurrentPageType();

    const handleClick = ({
      categoryName,
      categoryLevel,
    }: {
      categoryName: string;
      categoryLevel: number;
    }) => {
      const params: TriggerClickBreadcrumbsParameters = {
        categoryName,
        categoryPath: window.location.href,
        categoryLevel,
        source: currentPageType,
      };
      $tagManager.events.triggerClickBreadcrumbsTags(params);
    };

    const handleIntersectionCallback = (entries: IntersectionObserverEntry[]): void => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          showRightArrow.value = false;
        } else {
          showRightArrow.value = true;
        }
      });
    };
    const handleIntersectionCallbackFirstItem = (entries: IntersectionObserverEntry[]): void => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          showLeftArrow.value = false;
        } else {
          showLeftArrow.value = true;
        }
      });
    };
    useIntersectionObserver(lastItemHtml, handleIntersectionCallback);
    useIntersectionObserver(firstItemHtml, handleIntersectionCallbackFirstItem);

    const onClickRightArrow = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollBy({ left: BREADCRUMB_SCROLL_OFFSET, behavior: SCROLL_BEHAVIOR_SMOOTH });
      }
    };
    const onClickLeftArrow = () => {
      if (scrollContainer.value) {
        scrollContainer.value.scrollBy({ left: -BREADCRUMB_SCROLL_OFFSET, behavior: SCROLL_BEHAVIOR_SMOOTH });
      }
    };

    return {
      lastItem,
      breadcrumbLink,
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
      BREADCRUMBS_HOMEPAGE_PROP_NAME,
      handleClick,
      lastItemHtml,
      showRightArrow,
      onClickRightArrow,
      scrollContainer,
      onClickLeftArrow,
      showLeftArrow,
      firstItemHtml,
    };
  },
});
